// extracted by mini-css-extract-plugin
export default {"description":"style_description__y3smU","fade-in":"style_fade-in__1nZTB","top":"style_top__SeUYD","image":"style_image__YINsa"};